import { isNative } from 'src/utils/platform';
import { PushNotifications } from '@capacitor/push-notifications';
import { initOneSignal } from 'src/modules/push-notifications/Onesignal';

export const initPushNotifications = async () => {
  if (!isNative()) {
    return;
  }

  await PushNotifications.register();
  initOneSignal();

  await PushNotifications.addListener('registrationError', err => {
    console.error('Push Notifications Registration error: ', err.error);
  });
};

export const getDeliveredNotifications = async () => {
  const notificationList = await PushNotifications.getDeliveredNotifications();
  console.warn('delivered notifications', notificationList);
};
